import { normalizeWhitespace } from "@/utils";

/**
 * Embodiment 카탈로그의 조회 축. URL 이 소유한다(rules.md §17). 그래서 새로고침과 딥링크에서도 유지된다.
 * 축은 서버 `search`(name/model/tag contains) 하나뿐이므로 클라이언트에서 거르지 않는다.
 */
export type EmbodimentFilterState = {
  search: string;
};

export const EMPTY_EMBODIMENT_FILTERS: EmbodimentFilterState = { search: "" };

const PARAM = { search: "search" } as const;

export function readEmbodimentFilters(params: URLSearchParams): EmbodimentFilterState {
  return { search: normalizeWhitespace(params.get(PARAM.search) ?? "") };
}

// 자기 키만 지우고 다시 쓴다. 탭(`tab`) 같은 다른 키는 바꾸지 않는다. 입력은 변경하지 않는다.
export function writeEmbodimentFilters(
  params: URLSearchParams,
  state: EmbodimentFilterState,
): URLSearchParams {
  const next = new URLSearchParams(params);
  const search = normalizeWhitespace(state.search);
  if (search === "") {
    next.delete(PARAM.search);
  } else {
    next.set(PARAM.search, search);
  }
  return next;
}

export type EmbodimentFilterChip = {
  axis: keyof EmbodimentFilterState;
  label: string;
};

export function embodimentFilterChips(state: EmbodimentFilterState): EmbodimentFilterChip[] {
  return state.search === "" ? [] : [{ axis: "search", label: `검색: ${state.search}` }];
}
